<template>
  <div>
    <div class="grid md:grid-cols-3 gap-y-3 md:gap-x-6">
      <!-- patient -->
      <div class="">
        <div class="">
          <sqr-input-display
            :label="$t('invoice_patient')"
            :placeholder="$t('invoice_patient_placeholder')"
            @click="patientSelectModal = true"
            :valid="!$v.patient.$invalid"
            :invalid="$v.patient.$error"
            :value="invoice.patient | patientLabel"
          />
          <div class="text-xs text-red-600" v-if="$v.patient.$error">
            {{ $t('validation_general') }}
          </div>
        </div>
        <patient-select-modal
          v-show="patientSelectModal"
          @selected="changePatient($event.id)"
          @close="patientSelectModal = false"
          :invoiceId="invoiceId"
          :validation="Boolean($v.patient.$error)"
        />
      </div>
      <!-- issuer -->
      <div class="">
        <issuer-select-modal
          v-show="issuerSelectModal"
          @selected="changeIssuer($event.id)"
          @close="issuerSelectModal = false"
          :invoiceId="invoiceId"
          :validation="Boolean($v.issuer.$error)"
        />

        <div class="">
          <sqr-input-display
            :label="$t('invoice_issuer')"
            :placeholder="$t('invoice_issuer_placeholder')"
            @click="issuerSelectModal = true"
            :valid="!$v.issuer.$invalid"
            :invalid="$v.issuer.$error"
            :value="invoice.issuer | practiceLabel"
          />
          <div class="text-xs text-red-600" v-if="$v.issuer.$error">
            {{ $t('validation_general') }}
          </div>
          <!-- <sqr-input-checkbox
            class="mt-1"
            :placeholder="$t('invoice_provider_is_issuer')"
            :value="invoice.noProvider"
            @change="changeNoProvider"
          /> -->
        </div>
      </div>
      <!-- provider -->
      <div class="">
        <provider-select-modal
          v-show="providerSelectModal"
          @selected="changeProvider($event.id)"
          @close="providerSelectModal = false"
          :invoiceId="invoiceId"
          :validation="Boolean($v.provider.$error)"
        />

        <div class="">
          <sqr-input-display
            :label="$t('invoice_provider')"
            :placeholder="$t('invoice_provider_placeholder')"
            @click="providerSelectModal = true"
            :valid="!$v.provider.$invalid"
            :invalid="$v.provider.$error"
            :value="invoice.provider | practiceLabel"
          />
          <div class="help is-danger" v-if="$v.provider.$error">
            {{ $t('validation_general') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SqrInputDisplay from '@/components/SqrInputDisplay';

import PatientSelectModal from '@/components/PatientSelectModal';
import IssuerSelectModal from '@/components/IssuerSelectModal';
import ProviderSelectModal from '@/components/ProviderSelectModal';

import patientLabel from '@/filters/patient';
import practiceLabel from '@/filters/practice';

export default {
  name: 'InvoiceHeaderForm',
  components: {
    SqrInputDisplay,
    PatientSelectModal,
    IssuerSelectModal,
    ProviderSelectModal
  },
  filters: { patientLabel, practiceLabel },
  props: {
    aid: String,
    invoiceId: { type: String, required: true },
    invoice: { type: Object, default: () => ({}) },
    validations: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      patientSelectModal: false,
      issuerSelectModal: false,
      providerSelectModal: false
    };
  },
  computed: {
    ...mapGetters('patients', {
      patientsRaw: 'records',
      patientsLoading: 'loading'
    }),
    ...mapGetters('account', {
      accountLoading: 'loading',
      account: 'account',
      issuersRaw: 'issuers',
      providersRaw: 'providers'
    }),
    $v() {
      return this.validations;
    },
    patients() {
      let fromInvoice = [];
      let patientId = '';
      if (this.invoice && this.invoice.patient) {
        patientId = this.invoice.patientId || 'embeded';
        fromInvoice.push({
          id: patientId,
          name: patientLabel(this.invoice.patient)
        });
      }
      return [
        ...fromInvoice,
        ...this.patientsRaw.filter(p => p.id !== patientId)
      ];
    },
    issuers() {
      let fromInvoice = [];
      let issuerId = '';
      if (this.invoice && this.invoice.issuer) {
        issuerId = this.invoice.issuer.id || 'embeded';
        fromInvoice.push({
          id: issuerId,
          name: practiceLabel(this.invoice.issuer)
        });
      }
      return [
        ...fromInvoice,
        ...this.issuersRaw.filter(i => i.id !== issuerId)
      ];
    },
    providers() {
      let fromInvoice = [];
      let providerId = '';
      if (this.invoice && !this.invoice.noProvider && this.invoice.provider) {
        providerId = this.invoice.provider.id || 'embeded';
        fromInvoice.push({
          id: providerId,
          name: practiceLabel(this.invoice.provider)
        });
      }
      return [
        ...fromInvoice,
        ...this.providersRaw.filter(p => p.id !== providerId)
      ];
    }
  },
  mounted() {
    // this.loadPatients({});
    // this.loadIssuers({});
    // this.loadProviders({});
  },
  methods: {
    // ...mapActions('patients', {loadPatients: 'load'}),
    // ...mapActions('issuers', {loadIssuers: 'load'}),
    // ...mapActions('providers', {loadProviders: 'load'}),

    async changePatient(id) {
      try {
        this.$emit('change', { field: 'patientId', value: id });
        if (id !== 'embeded') {
          const snap = await this.$db()
            .doc(`accounts/${this.aid}/patients/${id}`)
            .get();
          const patient = snap.data();
          this.$emit('change', { field: 'patient', value: patient });
        }
        this.patientSelectModal = false;
      } catch (error) {
        console.log(error);
      }
    },
    async changeIssuer(id) {
      try {
        this.$emit('change', { field: 'issuerId', value: id });
        if (id !== 'embeded') {
          const issuer = this.account.issuers[id];
          this.$emit('change', { field: 'issuer', value: issuer });
        }
        this.issuerSelectModal = false;
      } catch (error) {
        console.log(error);
      }
    },
    changeNoProvider(noProvider) {
      this.$emit('change', { field: 'noProvider', value: noProvider });
      if (noProvider) {
        this.$emit('change', { field: 'providerId', value: '' });
        this.$emit('change', { field: 'provider', value: {} });
      }
    },
    async changeProvider(id) {
      try {
        this.$emit('change', { field: 'providerId', value: id });
        this.$emit('change', { field: 'noProvider', value: false });
        if (id !== 'embeded') {
          const provider = this.account.providers[id];
          this.$emit('change', { field: 'provider', value: provider });
        }
        this.providerSelectModal = false;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
